"use client";

import React, { useState } from 'react';
import Image from 'next/image';
import { Play } from 'lucide-react';

export function YouTubePlayer({ youtubeId, title = "Official Music Video" }) {
  const [isPlaying, setIsPlaying] = useState(false);

  if (!youtubeId) return null;

  const thumbnailUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;

  if (isPlaying) {
    return (
      <div className="rounded-2xl overflow-hidden shadow-xl border border-border bg-black aspect-video relative">
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1`}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full border-0"
        ></iframe>
      </div>
    );
  }

  return (
    <div 
      className="rounded-2xl overflow-hidden shadow-xl border border-border bg-black aspect-video relative group cursor-pointer"
      onClick={() => setIsPlaying(true)}
    >
      <Image
        src={thumbnailUrl}
        alt={title}
        fill
        sizes="(max-width: 768px) 100vw, 400px"
        className="object-cover group-hover:scale-105 transition-transform duration-500 opacity-90 group-hover:opacity-100"
      />
      <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-colors flex items-center justify-center">
        <button
          type="button"
          aria-label={`Play ${title}`}
          className="w-16 h-12 md:w-20 md:h-14 bg-red-600 hover:bg-red-700 text-white rounded-2xl flex items-center justify-center shadow-2xl transition-transform transform group-hover:scale-110 active:scale-95 cursor-pointer"
        >
          <Play className="w-7 h-7 fill-current ml-1" />
        </button>
      </div>
    </div>
  );
}
